import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ErrorScreen } from '@atlassian/generative-ai-modal/screens/Error';
import globalMessages from '../../messages';
import { FormattedMessage } from 'react-intl-next';
import { useAnalyticsFlowEventsQueue } from '../../analytics/analytics-flow/analyticsFlowUtils';
export function RateLimitScreenWithLogic({
  loadingState,
  endExperience,
  send,
  errorInfo
}) {
  // TODO AIFOLLOWUP
  // analytics events should be hit when entering the failed state
  const documentationLink = `https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/`;

  // https://developer.atlassian.com/platform/localization/i18n-formatting/avoiding-concatenation/#links
  const errorMsg = /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, globalMessages.rateLimitEnforced, {
    values: {
      link: message => /*#__PURE__*/React.createElement("a", {
        href: documentationLink,
        target: "_blank",
        rel: "noopener noreferrer"
      }, message)
    }
  }));
  useAnalyticsFlowEventsQueue({
    stepName: 'apiError',
    attributes: {
      errorType: loadingState === 'rate limit active' ? 'rate limit enforced' : 'rate limit lifted',
      ...errorInfo
    }
  });
  return /*#__PURE__*/React.createElement(ErrorScreen, {
    text: errorMsg,
    onCancel: () => {
      endExperience();
    },
    showRetryButton: false,
    onRetry: () => {
      send({
        type: 'api retry'
      });
    }
  });
}